import { API, CompetitionAPI } from '@brg/api';
import { useEffect, useState } from 'react';
import useLocalization from '../useLocalization';
export var useGetCompetition = function (competitionId, disabled) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!competitionId || disabled)
            return;
        setIsLoading(true);
        CompetitionAPI.Get({ idCompetition: competitionId })
            .then(function (v) { return v.json(); })
            .then(function (v) { return API.toLang(v, language); })
            .then(function (v) {
            setIsLoading(false);
            if (!v) {
                setError(true);
                return;
            }
            setResp(v || []);
        });
    }, [competitionId, disabled]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetCompetition.js.mapimport { API, CompetitionAPI } from '@brg/api';
import { useEffect, useState } from 'react';
import useLocalization from '../useLocalization';
export var useGetCompetition = function (competitionId, disabled) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!competitionId || disabled)
            return;
        setIsLoading(true);
        CompetitionAPI.Get({ idCompetition: competitionId })
            .then(function (v) { return v.json(); })
            .then(function (v) { return API.toLang(v, language); })
            .then(function (v) {
            setIsLoading(false);
            if (!v) {
                setError(true);
                return;
            }
            setResp(v || []);
        });
    }, [competitionId, disabled]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetCompetition.js.map